import { apiPost } from "~/services/api";
import type { RequestForm } from "~/types/main";

export const FormApi = {
  postRequestForm: (body: RequestForm) => {
    return apiPost({
      url: "/api/form/submit",
      body,
    });
  },
};
